import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { LcpService } from 'src/app/services/lcp/lcp.service';
import { environment } from 'src/environments/environment';
import { AuthService } from '../../auth.service';

@Component({
  selector: 'route-fortify-v2-accounts',
  templateUrl: './fortify-v2-accounts.component.html',
  styleUrls: ['./fortify-v2-accounts.component.scss']
})
export class FortifyV2AccountsComponent implements OnInit {
  loading!: boolean;
  orgList : Array<any> = [];
  orgCodesFromFortify: any;
  loggedInUser: string;
  email: string;
  name: string;
  preferred_username: string;
  accounts_username: string;
  accounts_supporUsername: string;

  constructor(
    private auth: AuthService,
    private lcpService : LcpService,
    private route: ActivatedRoute
  ) {

    this.route.data.subscribe( res => {
      console.log('Activated Route data : ' + JSON.stringify(res));
      this.setDisplays(res.data);
    })

   }

  ngOnInit() {
    document.body.style.paddingTop = "0px"; // unit measured in Edge.


  }


  logout(): void {
    console.log('Logging out from AuthService OIDC');
    this.auth.logout();
  }

  setDisplays(res) {;
      this.accounts_username = res.Username;
      this.accounts_supporUsername = res.SupportUsername;
      this.orgList = res.Accounts;
      this.loading = false;
  }

  setOrgCode(org:any) {
    this.lcpService.setOrgCode(org.OrgCode, this.orgList)
    .subscribe(res => {
      console.log('setOrgCode() : ' + JSON.stringify(res));
      if ( res.AccountType == 'Admin' ) { // Admin
        console.log('------ Logging as Administrator --------');
        window.location.href = `${environment.webAppUrl}/Projects/UserAgreement`;
      }
      if ( res.AccountType == 'Contractor' ) { // Contractor
        console.log('------ Logging as Contractor --------');
        window.location.href = `${environment.webAppUrl}/Projects/UserAgreement`;
      }
    })

  }

  
  prepopulateFakeAccounts() {
    this.orgList = [
      {"OrgCode":"49ers_tonic_output","Name":"TONIC LEVI'S STADIUM","FortifyEnabled":false},
      {"OrgCode":"aecom2","Name":"HUNT/CLAYCO JV","FortifyEnabled":false},
      {"OrgCode":"bmacdc","Name":"BMAC CONSULTING GROUP, LLC 2","FortifyEnabled":false},
      {"OrgCode":"cert_testfederal","Name":"(A) TEST DATABASE - FEDERAL","FortifyEnabled":true},
      {"OrgCode":"49ers_tonic_output","Name":"TONIC LEVI'S STADIUM","FortifyEnabled":false},
      {"OrgCode":"aecom2","Name":"HUNT/CLAYCO JV","FortifyEnabled":false},
      {"OrgCode":"bmacdc","Name":"BMAC CONSULTING GROUP, LLC 2","FortifyEnabled":false},
      {"OrgCode":"cert_testfederal","Name":"(A) TEST DATABASE - FEDERAL","FortifyEnabled":true},
      {"OrgCode":"49ers_tonic_output","Name":"TONIC LEVI'S STADIUM HUNT/CLAYCO JV (A) TEST DATABASE - FEDERAL","FortifyEnabled":false},
      {"OrgCode":"aecom2","Name":"HUNT/CLAYCO JV","FortifyEnabled":false},
      {"OrgCode":"bmacdc","Name":"BMAC CONSULTING GROUP, LLC 2","FortifyEnabled":false},
      {"OrgCode":"cert_testfederal","Name":"(A) TEST DATABASE - FEDERAL","FortifyEnabled":true},
      {"OrgCode":"49ers_tonic_output","Name":"TONIC LEVI'S STADIUM","FortifyEnabled":false},
      {"OrgCode":"aecom2","Name":"HUNT/CLAYCO JV","FortifyEnabled":false},
      {"OrgCode":"bmacdc","Name":"BMAC CONSULTING GROUP, LLC 2","FortifyEnabled":false},
      {"OrgCode":"cert_testfederal","Name":"(A) TEST DATABASE - FEDERAL","FortifyEnabled":true},
      {"OrgCode":"49ers_tonic_output","Name":"TONIC LEVI'S STADIUM","FortifyEnabled":false},
      {"OrgCode":"aecom2","Name":"HUNT/CLAYCO JV","FortifyEnabled":false},
      {"OrgCode":"bmacdc","Name":"BMAC CONSULTING GROUP, LLC 2","FortifyEnabled":false},
      {"OrgCode":"cert_testfederal","Name":"(A) TEST DATABASE - FEDERAL","FortifyEnabled":true},
      {"OrgCode":"49ers_tonic_output","Name":"TONIC LEVI'S STADIUM","FortifyEnabled":false},
      {"OrgCode":"aecom2","Name":"HUNT/CLAYCO JV","FortifyEnabled":false},
      {"OrgCode":"bmacdc","Name":"BMAC CONSULTING GROUP, LLC 2","FortifyEnabled":false},
      {"OrgCode":"cert_testfederal","Name":"(A) TEST DATABASE - FEDERAL","FortifyEnabled":true},
      {"OrgCode":"49ers_tonic_output","Name":"TONIC LEVI'S STADIUM","FortifyEnabled":false},
      {"OrgCode":"aecom2","Name":"HUNT/CLAYCO JV","FortifyEnabled":false},
      {"OrgCode":"bmacdc","Name":"BMAC CONSULTING GROUP, LLC 2","FortifyEnabled":false},
      {"OrgCode":"cert_testfederal","Name":"(A) TEST DATABASE - FEDERAL","FortifyEnabled":true}
    ];
    console.log(this.orgList)
  }

}
